import React from 'react';
import Tabs from '@src/new-components/Tabs';
import { VOICE_SELECTION_TABS } from '@src/constants/voiceLibrary';
import { COLOR } from '@src/styles/color';
import { StyledVoiceSelectionDialogTitle } from './index.style';
import ButtonLeaderboard from '../VoiceLeaderboard/ButtonLeaderboard';

const VoiceTabSelection = ({ activeTab, handleChangeTab }) => (
  <StyledVoiceSelectionDialogTitle>
    <Tabs
      tabs={VOICE_SELECTION_TABS}
      activeTab={activeTab}
      onChange={handleChangeTab}
      styleTab={{
        borderRadius: '0',
        backgroundColor: 'transparent',
        activeBackgroundColor: COLOR.white,
        activeBorderRadius: '8px',
        padding: '12px 16px',
      }}
      styleTabs={{
        gap: '0px',
        height: '48px',
        borderRadius: '12px',
        boxSizing: 'border-box',
        overflow: 'hidden',
        backgroundColor: COLOR.activeMenu,
        padding: '4px',
      }}
      activeTextVariant="body-16-semibold"
      textVariant="body-16-semibold"
    />
    <ButtonLeaderboard
      styles={{
        position: 'absolute',
        right: '40px',
        marginRight: '24px',
      }}
    />
  </StyledVoiceSelectionDialogTitle>
);

export default VoiceTabSelection;
